import React, { Component } from 'react';
import { connect } from 'react-redux';
import Upload from '../../upload/Upload';
import { api_config } from '@/constants/api';
import actions from '@/redux/action';
import { request } from '@/api/request';
import { message } from 'antd';
import sentGAEvent from '@/ga';
import { withTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { getVideoSize } from '@/utils/common';
import dynamicPhotoPic from '@/assets/images/dyeximg.png';
import dynamicPhotoShape from '@/assets/images/dynamic-photo-shape.png';
import dynamicPhotoTransform from '@/assets/images/transform.png';
import dynamicPhotoBg from '@/assets/images/bg-shape.svg';
import dynamicPhotoGIF from '@/assets/images/dyexgif.gif';
import DownloadPage from '../children/DownloadPage';
import Indraw from '../children/draw';
import Device from 'current-device';
import DynamicPhotoWorkFunction from './children/dynamicPhotoWorkFunction/DynamicPhotoWorkFunction';
import DynamicPhotoWorkEmailFunction from './children/dynamicPhotoWorkEmailFunction/DynamicPhotoWorkEmailFunction';
import '@/assets/dynamicPhoto.less';

class DynamicPhotoWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageAccept: '.gif, .jpg, .jpeg, .png, .bmp, .tiff, .web, .ico',
      step: 0,
      hasEmail: true,
      waitingTime: 0,
      email: '13145846564.@163.com',
      wsnumber: '',
      wsSuccess: 1, // 0:啥都没有 1：draw中 2：draw完成
      item: { status: 2, progress: 0, wait_front: 0 },
      successBymp4: '',
      websocketObj: null,
      networkStatus: true,
      loadding: false,
      drawTime: 0,
      netRetryTimer: false,
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem('originUrl') &&
      localStorage.getItem('wsnumber') &&
      localStorage.getItem('successBymp4')
    ) {
      this.setState({
        successBymp4: localStorage.getItem('successBymp4'),
        wsnumber: localStorage.getItem('wsnumber'),
        wsSuccess: 2,
        step: 1,
      });
      // 调整成功页面埋点
      sentGAEvent({
        category: 'PageView',
        action: 'AnimateOld_GenerateSuccessPageView',
        label: 'Null',
      });
    } else {
      // 加页面加载埋点
      sentGAEvent({
        category: 'PageView',
        action: 'AnimateOld_FrontPageView',
        label: 'Null',
      });
    }

    window.addEventListener('offline', () => {
      message.warn(this.props.t('common:Network Error'));
      this.setState({
        networkStatus: false,
      });
    });
    window.addEventListener('online', () => {
      this.setState({
        networkStatus: true,
      });
    });
  }

  handelNextStep = (step) => {
    this.setState({ step: 1 });
    this.retryInitwebsock();
  };

  handleSubmit = async (callback) => {
    if (this.state.loadding) {
      return;
    }
    this.setState({ loadding: true });

    const url = this.props.currFile.videofileurl;
    localStorage.setItem('originUrl', url);
    this.requstDynamicPhoto(url)
      .then((response) => {
        this.setState({ loadding: false });
        if (response.code === 200) {
          const waitingTime = response.data.eta_minutes;
          const email = response.data.email;
          const wsnumber = response.data.result.number[0];
          this.setState({ waitingTime, email, wsnumber, wsSuccess: 1 });
          this.setState({
            item: { status: 2, progress: 0, wait_front: 1 },
          });
          localStorage.setItem('wsnumber', wsnumber);
          if (callback) {
            callback(wsnumber);
          }
        } else {
          if (response.code === 402102) {
            sentGAEvent({
              category: 'UpgradePrompShow',
              action: '22AO_UpgradePrompShow',
            });
            this.props.onPurchaseModalObjChange({
              // visible: true,
              // type: 'videoEditorTimesMoreThanLimit',
              trigger: '6TrialOver',
            });
            let obj = {
              visible: true,
              text: 'UpgradeToUploadLimits',
            };

            this.props.onExceed2M(obj);

            sentGAEvent({
              category: 'Upgrade',
              action: 'Old6TrialOver_PrompShow',
              label: '',
            });
            this.setState({
              step: 0,
            });
          } else {
            this.setState({
              item: { status: 3, progress: 0, wait_front: 1 },
            });
            this.backToHome();
            this.setState({ loadding: false });
            message.warn(this.props.t('common:Network Error'));
          }
        }
      })
      .catch((res) => {
        this.setState({
          item: { status: 3, progress: 0, wait_front: 1 },
        });
        this.backToHome();
        this.setState({ loadding: false });
        message.warn(this.props.t('common:Connection server failed.'));
      });
  };

  handleSubmitEmail = async (form, callback) => {
    let response = await this.requstEmail(
      form.email,
      form.firstName,
      form.lastName
    );
    if (response.code === 200) {
      if (callback) {
        callback();
      }
    } else {
      message.error(this.props.t('Too many attempts, please try again later.'));
    }
  };

  handleSubmitVerifyCode = async (email, code, succCallback, errCallback) => {
    let response = await this.requstVerifyCode(email, code);
    if (response.code === 200) {
      sentGAEvent({
        category: 'AnimateOld',
        action: 'OldSuccess',
      });
      if (succCallback) {
        succCallback();
      }
      this.setState({ hasEmail: true });
      this.handleSubmit();
    } else {
      if (errCallback) {
        errCallback();
      }
    }
  };

  requstDynamicPhoto = (url) => {
    const formData = new FormData();
    formData.append('template', 'sample.mov');
    formData.append('photo_url', url);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`dynamicPhoto`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getLanguageFormData = () => {
    const language = window.Storage.get('page-lang');
    let lang = 'en';
    if (language) {
      switch (language) {
        case 'in':
          lang = 'ih';
          break;
        default:
          lang = language;
          break;
      }
    }
    return lang;
  };

  requstEmail = (email, first_name, last_name) => {
    const formData = new FormData();
    formData.append('email', email);
    if (first_name) {
      formData.append('first_name', first_name);
    }
    if (last_name) {
      formData.append('last_name', last_name);
    }
    formData.append('token', this.props.tokenId);
    formData.append('language', this.getLanguageFormData());
    return new Promise((resolve, reject) => {
      request(`sendVerificationCode`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  requstVerifyCode = (email, verification_code) => {
    const formData = new FormData();
    verification_code = verification_code.replace(/\s+/g, '');
    formData.append('email', email);
    formData.append('verification_code', verification_code);
    formData.append('token', this.props.tokenId);
    return new Promise((resolve, reject) => {
      request(`verifyEmail`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  uploadHasEmailCallback = (email, waitingTime) => {
    this.setState({ isNotVerify: true });
    console.log('?????????????');
    this.handleSubmit((wsnumber) => {
      // this.setState({ step: 1, hasEmail: true, email, waitingTime })

      // websocket
      this._initWebsocket(wsnumber);
    });
  };

  // 链接websocket

  retryInitwebsock = () => {
    // if(this.state.wsnumber.length>0){

    // }else{
    //   this.setState({
    //     step:0
    //   })
    // }

    this.handleSubmit((wsnumber) => {
      this._initWebsocket(wsnumber);
    });
  };

  backToHome = () => {
    this.setState({
      step: 0,
      wsSuccess: 1,
      item: { status: 2, progress: 0, wait_front: 1 },
    });
    sentGAEvent({
      category: 'EnterFuncPage',
      action: '22AO_EnterFuncPage',
      label: 'Null',
    });
    localStorage.removeItem('originUrl');
    localStorage.removeItem('wsnumber');
    localStorage.removeItem('successBymp4');
  };

  cancelTask = () => {
    Modal.confirm({
      title: '',
      content: this.props.t(
        'The processing will be completed soon, are you sure you want to cancel it?'
      ),
      okText: this.props.t('common:Confirm'),
      cancelText: this.props.t('common:Cancel'),
      className: 'costomLm',
      closable: true,
      onOk: () => {
        console.log('ok');
        // 取消任务
        this.backToHome();
        // 如果开启了websocket则关闭
        if (this.state.websocketObj?.close) {
          console.log('我要取消了');
          this.state.websocketObj.close();
          this.setState({
            websocketObj: null,
          });
        } else {
          // 断网情况下不轮询
          if (!this.state.networkStatus) {
            return;
          }
          const timer = setInterval(() => {
            console.log('定时轮询下次的我要取消');
            if (this.state.websocketObj?.close) {
              console.log('轮询执行了取消');
              this.state.websocketObj.close();
              this.setState({
                websocketObj: null,
              });
              clearInterval(timer);
            }
          }, 100);
        }
      },
      onCancel: () => {
        console.log('cancel');
      },
    });
  };

  _initWebsocket = (number) => {
    if (!this.state.networkStatus) {
      clearTimeout(this.state.netRetryTimer);
      console.log('轮询断网了~');
      message.warn(this.props.t('common:Network Error'));
      let netRetryTimer = setTimeout(() => {
        this._initWebsocket(number);
      }, 3000);
      this.setState({ netRetryTimer: netRetryTimer });
      return;
    }
    const websocketUrl = `${api_config.WS_API_URL}/progressbar`;
    try {
      let websocket = new WebSocket(websocketUrl);
      sentGAEvent({
        category: 'AnimateOld',
        action: 'AnimateOld_GenerateStart',
        label: 'Null',
      });
      sentGAEvent({
        category: 'ProcessStart',
        action: '22AO_ProcessStart',
        label: '',
      });
      const drawTime = new Date().getTime();
      this.setState({
        websocketObj: websocket,
        item: { status: 2, progress: 0, wait_front: 1 },
      });
      websocket.onopen = (evt) => {
        console.log('open');
        websocket.send(`{"number":"${number}","is_info":1}`);
      };
      websocket.onclose = (evt) => {
        console.log('我断开了哦!');
        this.setState({
          websocketObj: null,
        });
      };
      websocket.onmessage = (evt) => {
        console.log(JSON.parse(evt.data));
        const wsRes = JSON.parse(evt.data);
        if (wsRes.code === 200 && wsRes.data.status === 1) {
          // 完成
          this.setState({
            item: {
              status: wsRes.data.status,
              progress: 100,
              wait_front: 0,
            },
            wsSuccess: 2,
            successBymp4: wsRes.data.info[0].url,
          });
          // 调整成功页面埋点
          sentGAEvent({
            category: 'PageView',
            action: 'AnimateOld_GenerateSuccessPageView',
            label: 'Null',
          });

          // 处理成功埋点
          const endTime = new Date().getTime();
          getVideoSize(wsRes.data.info[0].url).then((res) => {
            sentGAEvent({
              category: 'AnimateOld',
              action: 'AnimateOld_GenerateSuccess',
              label: `${res}_${(endTime - drawTime) / 1000}s`,
            });
            sentGAEvent({
              category: 'ProcessSuccess',
              action: '22AO_ProcessSuccess',
              label: ``,
            });
          });

          localStorage.setItem('successBymp4', wsRes.data.info[0].url);
        } else if (wsRes.code === 200 && wsRes.data.status === 0) {
          // 在等待
          this.setState({
            item: {
              status: 0,
              progress: 0,
              wait_front: wsRes.data.info[0].wait_front,
            },
          });
        } else if (wsRes.code === 200 && wsRes.data.status === 3) {
          // 处理失败，
          this.setState({
            item: {
              status: 3,
              progress: 0,
              wait_front: 0,
            },
          });
          sentGAEvent({
            category: 'AnimateOld',
            action: 'AnimateOld_GenerateFail',
            label: ``,
          });
        } else if (wsRes.code === 200 && wsRes.data.status === 2) {
          // 处理中
          this.setState({
            item: {
              status: 2,
              progress: wsRes.data.progress,
              wait_front: 0,
            },
          });
        }
      };
      websocket.onerror = (evt) => {
        console.log(evt);
      };
    } catch (error) {
      console.log(error);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.currFile !== this.props.currFile &&
      prevProps.currFile &&
      this.props.currFile &&
      !prevProps.currFile.uploadStatus &&
      this.props.currFile.uploadStatus
    ) {
      this.setState({ step: 1 });
    }
  }

  componentDidMount() {
    console.log('页面加载完成');
    sentGAEvent({
      category: 'EnterFuncPage',
      action: '22AO_EnterFuncPage',
      label: 'Null',
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className='workplace'>
        {this.props.currFile &&
        this.props.currFile.uploadStatus &&
        this.state.step === 0 ? (
          <DynamicPhotoWorkFunction
            handelNextStep={this.handelNextStep}
            currFile={this.props.currFile}
            handleCloseFile={() => this.props.onCurrFileChange(null)}
          />
        ) : this.state.step === 0 ? (
          <div className='workplace-upload'>
            <Upload
              size='small'
              theme='light'
              visible
              accept={this.state.imageAccept}
              work='dynamicPhoto'
              isCropPreload
              isShowUploadProcess
              hideCancelText
              showProcessText
              uploadHasEmailCallback={this.uploadHasEmailCallback}
              uploadBtnText={t('Upload a photo')}
              uploadNoteText={t(
                'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.'
              )}
            />
            <div className='workplace-rgt'>
              <img src={dynamicPhotoBg} className='staic-bg' alt='dynamic' />
              <div className='static'>
                <img
                  className='transfrom-icon'
                  src={dynamicPhotoTransform}
                  alt='dynamic'
                />
                <img
                  className='static-pic'
                  src={dynamicPhotoPic}
                  alt='dynamic'
                />
                <img className='shape' src={dynamicPhotoShape} alt='dynamic' />
              </div>
              <img className='dynamic' src={dynamicPhotoGIF} alt='dynamic' />
            </div>
          </div>
        ) : null}
        {/* {this.state.step === 1 && (
          <DynamicPhotoWorkEmailFunction
            isNotVerify={this.state.isNotVerify}
            hasEmail={this.state.hasEmail}
            email={this.state.email}
            waitingTime={this.state.waitingTime}
            handleSubmitEmail={this.handleSubmitEmail}
            handleSubmitVerifyCode={this.handleSubmitVerifyCode}
            handelNextStep={this.handelNextStep}
          />
        )} */}
        {this.state.wsSuccess === 2 && (
          <DownloadPage
            job_id={this.state.wsnumber}
            successBymp4={this.state.successBymp4}
            originUrl={
              this.props.currFile?.videofileurl ||
              localStorage.getItem('originUrl')
            }
            backToHome={this.backToHome}
          />
        )}
        {this.state.step === 1 &&
          (this.state.wsSuccess === 1 || this.state.wsSuccess === 0) && (
            <Indraw
              src={this.props.currFile?.videofileurl || ''}
              item={this.state.item}
              retryInitwebsock={this.retryInitwebsock}
              backToHome={this.cancelTask}
            />
          )}
        {/* <DynamicPhotoWorkFailedRender /> */}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  currFile: state.files.currFile,
  tokenId: state.common.tokenId,
  uploading: state.work.uploading,
});

const mapDispatchToProps = (dispatch) => ({
  onCurrFileChange: (currFile) => dispatch(actions.onCurrFileChange(currFile)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
  onExceed2M: (exceed) => dispatch(actions.onExceed2M(exceed)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['dynamicPhoto'])(DynamicPhotoWork));
